"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketItemLocalId = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var attribute_1 = require("../attribute");
var measure_1 = require("../measure");
var ts_invariant_1 = tslib_1.__importStar(require("ts-invariant"));
/**
 * Gets value of local identifier of bucketItem
 *
 * @param bucketItem - bucketItem to work with
 * @returns value of local identifier
 * @public
 */
function bucketItemLocalId(bucketItem) {
    ts_invariant_1.default(bucketItem, "bucketItem must be specified");
    if (attribute_1.isAttribute(bucketItem)) {
        return attribute_1.attributeLocalId(bucketItem);
    }
    if (measure_1.isMeasure(bucketItem)) {
        return measure_1.measureLocalId(bucketItem);
    }
    throw new ts_invariant_1.InvariantError("Unknown bucketItem \"" + bucketItem + "\"");
}
exports.bucketItemLocalId = bucketItemLocalId;
//# sourceMappingURL=bucketItem.js.map